<template>
	<div  class="content_group "><!-- content_group -->
									<div  class="content_group_R  "><!-- content_group_R -->
									
										<!-- <div  class="search_wrap  ">
											<div class="search_box">
												<input type="text" class="search_input2" value=""  placeholder="输入查询内容" style="width:100%">
												<button type="button" class="search_btn2"></button>
											</div>
											<div class=" cei-select " name="cei-select">
												<i class="cei-icon icon-arrdown"></i>
												<input type="text" placeholder="时间不限" value=""  disabled>
												<ul>
												  <li><i></i>时间不限</li>
												  <li><i></i>11111111</li>
												  <li><i></i>333</li>
												  <li><i></i>111</li>
												  <li><i></i>222</li>
												  <li><i></i>333</li>
												</ul>
											</div>
											<div class=" cei-select " name="cei-select">
												<i class="cei-icon icon-arrdown"></i>
												<input type="text" placeholder="地区选择" value=""  disabled>
												<ul>
												  <li><i></i>11111</li>
												  <li><i></i>11111111</li>
												  <li><i></i>333</li>
												  <li><i></i>111</li>
												  <li><i></i>222</li>
												  <li><i></i>333</li>
												</ul>
											</div>
										</div> -->
									
									
										<div  class="thematic_list_out  "><!-- thematic_list_out -->
											<div  class="thematic_list2  "><!-- thematic_list -->
											<div style="min-height: 246px;width: 767px;">
												<el-skeleton :rows="5" :loading="loadingMask" animated >
												<section v-for="(result,index) in resultDataList" :key="result.id" >
													<dl>
														<dt>
															<div class="T-date">{{result.publishtime?result.publishtime.substring(0,10):''}}</div>
														</dt>
														<dd><a @click="jumppush('/detail/'+result.id+'?col='+sourcecol)" class="T-tit" v-html="result.title" target="_blank"></a></dd>
													</dl>
												</section>
												<!-- <section>
													<dl>
														<dt>
															<div class="T-date">2022-03-18</div>
														</dt>
														<dd><a href="" class="T-tit">国家生态工业示范园示范园区建设协调领导小组：部署推进国家生态工业示范园区碳达峰碳中和</a></dd>
													</dl>
												</section>
												<section>
													<dl>
														<dt>
															<div class="T-date">2022-03-18</div>
														</dt>
														<dd><a href="" class="T-tit">国家生态工业示范园示范园区建设协调领导小组：部署推进国家生态工业示范园区碳达峰碳中和</a></dd>
													</dl>
												</section>
												<section>
													<dl>
														<dt>
															<div class="T-date">2022-03-18</div>
														</dt>
														<dd><a href="" class="T-tit">国家生态工业示范园示范园区建设协调领导小组：部署推进国家生态工业示范园区碳达峰碳中和</a></dd>
													</dl>
												</section>
												<section>
													<dl>
														<dt>
															<div class="T-date">2022-03-18</div>
														</dt>
														<dd><a href="" class="T-tit">国家生态工业示范园示范园区建设协调领导小组：部署推进国家生态工业示范园区碳达峰碳中和</a></dd>
													</dl>
												</section> -->
												</el-skeleton>
											</div>
												<el-row v-if="totalResultCount>5" class="pagediv" style="justify-content: left;margin-top: 10px;">
													<el-pagination
																@current-change="changeSearchPage"
																:current-page="pageNum"
																:page-size="5"
																layout="total,prev, pager, next"
																:total="totalResultCount">
															</el-pagination>
												</el-row>
											</div><!-- /thematic_list -->
											
											<div class="ZT_img  "><img src="images/img_sjxw.png" width="400" height="288" alt=""/></div>
											
										</div><!-- /thematic_list_out -->
										
										
										<div class="m_b1"></div>
										
										<!-- <div class="iframecontainer"> -->
											<iframe style="width: 100%;" v-bind:src="iframesrc" v-bind:id="'iframe'+ztsubid" v-on:onload="iFrameHeight('iframe'+ztsubid)" v-bind:name="'iframe'+ztsubid"></iframe>
										<!-- </div> -->
										
										<!-- <div class="iframe_chart"><img src="images/iframe_chart_ST.jpg" width="100%" /></div>
										
										
										
										<ul class="data_sources">
											<li class="S"></li>
											<li class="M">数据来源：国家统计局。</li>
											<li class="S"></li>
										</ul> -->
										
										
									
	
							  </div><!-- /content_group_R -->
								</div><!-- /content_group -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 5,
				totalResultCount: 0,
				resultDataList: [],
				iframesrc:'',
				changeHeightInterval:null,
			}
		},
		props:[
			'ztsubid',
			'hasPower',
			'zxsjiframeurl',
			'sourcecol',
		],
		mounted:function(){
			this.searchfnc();
			this.iframesrc=this.zxsjiframeurl;
			let _timerthis=this;
			this.changeHeightInterval = setInterval(function (){
			    _timerthis.iFrameHeight('iframe'+_timerthis.ztsubid);
			}, 5000);
		},
		destroyed:function(){
			clearInterval(this.changeHeightInterval);
			this.changeHeightInterval=null;
		},
		computed: {
	
		},
		methods: {
			jumppush:function(to){
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'subject/getSubjectColumnArticles',
						responseType: 'json',
						params: {
							columnID:this.ztsubid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
			iFrameHeight:function(id) {
				var ifm= document.getElementById(id);
				var subWeb = document.frames ? document.frames[id].document :ifm.contentDocument;
				if(ifm != null && subWeb != null) {
					ifm.height = subWeb.getElementById('divMonitor').scrollHeight;
				}
			}
		}
	}
</script>

<style>
/* 	.iframecontainer{
		position: relative;
		overflow: hidden;
		height: 0;
		padding-bottom: 100%;
	}
	.iframecontainer iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	} */

</style>
